import axios from "axios";
import { ApiEndpoints } from "./ApiConstants";

const axiosInstance = axios.create({
    baseURL: ApiEndpoints.BASE_URL,
});

export const getUpcomingMatches = () => {
    return axiosInstance
        .get(ApiEndpoints.GET_SCHEDULED_MATCHES)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.response;
        });
};

export const getLiveMatches = () => {
    return axiosInstance
        .get(ApiEndpoints.LIVE_MATCHES)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.response;
        });
};

export const getSchedulerLiveMatches = () => {
    return axiosInstance
        .get("/scheduler/matches/live")
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.response;
        });
};

export const getPubNubToken = (userName, matchId, authToken) => {
    return axiosInstance
        .post("/message/token/match", {
            userName: userName,
            matchId: matchId
        }, {
            headers: {
                "AuthToken": authToken
            }
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.response;
        });
};

export const getMatchesCard = (type) => {
    return axiosInstance
        .get(`${ApiEndpoints.GET_MATCHES_CARD}?type=${type}&page=0&size=100`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.response;
        });
};